import axios from "axios";
import { applyMiddleware } from "redux";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
});

export default api;